export const LOGIN = '/login'

export const DASHBOARD = '/'

export const PRODUCTS = '/produtos'
export const PRODUCT_INFO = '/produtos/:id'
export const MANUFACTURERS = '/fabricantes'
export const PRODUCT_CATEGORIES = '/categorias'
export const PRODUCT_GROUPS = '/grupos'
export const PRODUCT_STOCK_TRACKING = '/produtos/:id/estoque'
export const PRODUCT_PRICES = '/produtos/alteracao/precos'

export const CUSTOMERS = '/clientes'
export const CUSTOMER_INFO = '/clientes/:id'

export const ORDERS = '/vendas/pedidos'
export const ORDER = '/vendas/pedido/:id'

export const CHECKOUT_CUSTOMER_PENDINGS = '/checkout/pendentes/:id'
export const CHECKOUT_PAYMENT = '/checkout/pagamento'
export const CHECKOUT_CONFIRMATION = '/checkout/confirmacao'

export const SALES_CHANNELS = '/configuracoes/canais-venda'
export const PAYMENT_METHODS = '/configuracoes/formas-pagamento'
export const PAYMENT_METHOD_INFO = '/configuracoes/formas-pagamento/:id'

export const REPORT_DAILY = '/relatorios/diario'
export const RECEIPT_REPORT = '/relatorios/recebimentos'

export const PAYMENT_PRINT = '/pagamentos/:id/print'

export const STOCK_ACTIVITY = '/estoque/registros'

export const ANALYTICS_CUSTOMERS = '/relatorios/clientes'
